"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSplitItemized = exports.checkIsNegativeValueForbidden = exports.calculatePercentage = exports.calculateNetPriceFromGrossPriceAndTaxRate = exports.mapExportFormatToExportInfoProperty = exports.isExpenseVendorDefined = exports.isMileageOrPerDiem = exports.isAtLeastReviewed = void 0;
const splitType_enum_1 = require("../models/expense/splitType.enum");
const exportFormat_enum_1 = require("../models/common/exportFormat.enum");
const expenseKind_enum_1 = require("../models/expense/expenseKind.enum");
const expenseStatus_enum_1 = require("../models/expense/expenseStatus.enum");
const vendorType_enum_1 = require("../models/expense/vendorType.enum");
const common_1 = require("./common");
const isAtLeastReviewed = (status) => status === expenseStatus_enum_1.ExpenseStatusEnum.REVIEWED || status === expenseStatus_enum_1.ExpenseStatusEnum.PAID || status === expenseStatus_enum_1.ExpenseStatusEnum.DONE;
exports.isAtLeastReviewed = isAtLeastReviewed;
const isMileageOrPerDiem = (expense) => [expenseKind_enum_1.ExpenseKindEnum.MILEAGE, expenseKind_enum_1.ExpenseKindEnum.PER_DIEM].includes(expense.kind);
exports.isMileageOrPerDiem = isMileageOrPerDiem;
const isExpenseVendorDefined = ({ vendorType, creditorUser, vendor }) => {
    if (!vendorType) {
        return false;
    }
    if (vendorType === vendorType_enum_1.VendorTypeEnum.USER && (creditorUser === null || creditorUser === void 0 ? void 0 : creditorUser._id)) {
        return true;
    }
    if (vendorType === vendorType_enum_1.VendorTypeEnum.VENDOR && (vendor === null || vendor === void 0 ? void 0 : vendor._id)) {
        return true;
    }
    return false;
};
exports.isExpenseVendorDefined = isExpenseVendorDefined;
const mapExportFormatToExportInfoProperty = (format) => {
    switch (format) {
        case exportFormat_enum_1.ExportFormatEnum.ALL:
            return "isExportedAsAll";
        case exportFormat_enum_1.ExportFormatEnum.INVOICES:
            return "isExportedAsInvoices";
        case exportFormat_enum_1.ExportFormatEnum.CSV:
            return "isExportedAsCSV";
        case exportFormat_enum_1.ExportFormatEnum.CSV_LEXWARE:
            return "isExportedAsLexwareCSV";
        case exportFormat_enum_1.ExportFormatEnum.DATEV:
            return "isExportedAsDatevZip";
        case exportFormat_enum_1.ExportFormatEnum.DATEV_INVOICE_CSV:
            return "isExportedAsDatevInvoiceCsv";
        case exportFormat_enum_1.ExportFormatEnum.DATEV_ONLINE:
            return "isExportedToDatevOnline";
        case exportFormat_enum_1.ExportFormatEnum.SEPA:
            return "isExportedAsSepa";
        case exportFormat_enum_1.ExportFormatEnum.NON_SEPA:
            return "isExportedAsNonSepa";
        // No export information associated with these enums
        case exportFormat_enum_1.ExportFormatEnum.MARK_AS_DONE:
        case exportFormat_enum_1.ExportFormatEnum.AUDIT_TRAIL:
        case exportFormat_enum_1.ExportFormatEnum.CHANGE_HISTORY:
        default:
            return undefined;
    }
};
exports.mapExportFormatToExportInfoProperty = mapExportFormatToExportInfoProperty;
const calculateNetPriceFromGrossPriceAndTaxRate = (grossPrice, taxRate) => 
/*
The tax rate percentage is always based on the net, not the gross.
This is why the net price can't be calculated by doing
gross.percentage(taxRate), but the calculation below is needed
*/
taxRate ? (0, common_1.toAmount)((0, common_1.toDinero)(grossPrice).divide(1 + taxRate / 100)) : grossPrice;
exports.calculateNetPriceFromGrossPriceAndTaxRate = calculateNetPriceFromGrossPriceAndTaxRate;
const calculatePercentage = ({ price, taxRate }) => price.percentage(taxRate, "HALF_AWAY_FROM_ZERO");
exports.calculatePercentage = calculatePercentage;
const checkIsNegativeValueForbidden = (status, kind) => status === expenseStatus_enum_1.ExpenseStatusEnum.PURCHASE_PENDING && kind !== expenseKind_enum_1.ExpenseKindEnum.SUBSCRIPTION;
exports.checkIsNegativeValueForbidden = checkIsNegativeValueForbidden;
const isSplitItemized = (splitType) => [splitType_enum_1.SplitTypeEnum.ITEM, splitType_enum_1.SplitTypeEnum.LINE_ITEM].includes(splitType);
exports.isSplitItemized = isSplitItemized;
